import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { MatTooltipModule } from '@angular/material';

@NgModule({
  imports: [ RouterModule, CommonModule, MatTooltipModule  ],
  declarations: [ SidebarComponent ],
  exports: [ SidebarComponent ],
})

export class SidebarModule {}
